import React from 'react'
import { connect } from 'react-redux'

import tooltips from '../constants/tooltips.json'

const StatusBar = (props) => {
  let {
    isBeta,
    statusMessage,
    editorVersion,
    showTooltips
  } = props

  let formattedMessage = statusMessage.replace(/\s+/g, '-')

  return (
    <div
      className="status-bar-message"
      data-tip={tooltips['device-status-message']}
      data-multiline="true"
      data-tip-disable={!showTooltips}
      >
      { isBeta && <span className="editor-version">v.{editorVersion}</span> }
      <span className="status-message">{statusMessage}</span>
      <div className="status-bar" data-status-message={formattedMessage}><span className="progress-bar"></span></div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    isBeta: state.editor.beta,
    statusMessage: state.editor.statusMessage,
    editorVersion: state.editor.editorVersion,
    showTooltips: state.editorPreferences.showTooltips
  }
}

export default connect(mapStateToProps, null)(StatusBar)
